import React from 'react';
import './App.css'; // Ensure the CSS file is imported

const Email = () => {
  return (
    <div className="email-container fade-in">
      <h2 className="email-title">letstalk@hbahousing.co.uk</h2>
    </div>
  );
};

export default Email;